"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var tabsCollection_1 = require("./tabsCollection");
var tabsCollection_2 = require("./tabsCollection");
exports.Tab = tabsCollection_2.Tab;
exports.SubTab = tabsCollection_2.SubTab;
var TabNav = /** @class */ (function () {
    function TabNav(config, preview, testFeatures, profanityFilter, externalButton, appState, scroller, $timeout) {
        this.enableAll = false;
        this.enableAll = config.importJson !== undefined;
        this.tabs = new tabsCollection_1.TabsCollection(externalButton, appState, preview, testFeatures, profanityFilter, scroller, $timeout, config.tabs, this.enableAll);
    }
    TabNav.prototype.setBook = function (book) {
        this.tabs.setBook(book);
    };
    return TabNav;
}());
exports.TabNav = TabNav;
function TabNavDirective(config, tabNav, track, appState) {
    return {
        templateUrl: config.params.base + "templates/form/tab-nav.html",
        scope: true,
        transclude: true,
        link: function (scope, element, attrs, ctrl, transclude) {
            transclude(scope, function (clone) {
                element.append(clone);
            });
        },
        controller: /** @class */ (function () {
            function TabNavController() {
                this.tabs = tabNav.tabs;
                this.svgPath = config.params.base + "img/symbols.svg";
            }
            TabNavController.prototype.onClick = function (tab) {
                if (!tab.tabIsEnabled() && !appState.debug) {
                    return;
                }
                var success = this.tabs.setActive(tab), subTabIndex = tab.subIndex, tabIndex = tab.parent ? tab.parent.tabIndex + 1 : tab.tabIndex + 1;
                if (!success) {
                    track.track({ eventAction: "fehler_" + this.getCurrentTabIndex() });
                }
                else if (isNaN(subTabIndex)) {
                    track.track({ eventAction: "tab-klick_" + tabIndex });
                }
                else {
                    track.track({ eventAction: "subtab-klick_" + tabIndex + ">" + (subTabIndex + 1) });
                }
            };
            TabNavController.prototype.nextTab = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var tabIndex, success;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                tabIndex = this.getCurrentTabIndex();
                                return [4 /*yield*/, this.tabs.setNextTab()];
                            case 1:
                                success = _a.sent();
                                if (success) {
                                    track.track({ eventAction: "weiter_" + tabIndex + ">" + (tabIndex + 1) }, true);
                                }
                                else {
                                    track.track({ eventAction: "fehler_" + tabIndex });
                                }
                                return [2 /*return*/];
                        }
                    });
                });
            };
            TabNavController.prototype.prevTab = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var tabIndex, success;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                tabIndex = this.getCurrentTabIndex();
                                return [4 /*yield*/, this.tabs.setPrevTab()];
                            case 1:
                                success = _a.sent();
                                if (success) {
                                    track.track({ eventAction: "zurueck_" + tabIndex + ">" + (tabIndex - 1) }, true);
                                }
                                else {
                                    track.track({ eventAction: "fehler_" + tabIndex });
                                }
                                return [2 /*return*/];
                        }
                    });
                });
            };
            TabNavController.prototype.getSubTabProgress = function () {
                return 100 / this.tabs.getSubTabCount() * (this.tabs.getSubTabIndex() + 1) || 100;
            };
            TabNavController.prototype.getTabProgress = function () {
                return Math.ceil(100 / this.getTabCount() * this.getCurrentTabIndex());
            };
            TabNavController.prototype.getCurrentTabIndex = function () {
                return this.tabs.getGlobalIndex() + 1;
            };
            TabNavController.prototype.getTabCount = function () {
                return this.tabs.getTabCount();
            };
            return TabNavController;
        }()),
        controllerAs: 'tabNav'
    };
}
exports.default = angular.module('pb.tabNav', [])
    .service('tabNav', TabNav)
    .directive('pbTabNav', TabNavDirective);
